import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';
import { useBusinessNumber } from '../../../../shared/hooks/useBusinessNumber.js';
import { useBusinessDay } from '../../../../shared/hooks/useBusinessDay.js';

interface StorageItem { readonly key: string; readonly sizeBytes: number; readonly contentType: string; readonly uploadedAt: string; }

export function StorageBrowserPage(): ReactNode {
  const { token } = useAuth();
  const { t } = useTranslation();
  const { number } = useBusinessNumber();
  // Dates follow the tenant's DISPLAY_DATE_FORMAT, not the reader's language picker.
  const { atDay } = useBusinessDay();
  const [rows, setRows] = useState<StorageItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ items: StorageItem[] }>('/platform/storage', { token })
      .then((r) => { if (alive) setRows(r.items); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('common.loading')}</p>;
  return (
    <main aria-label="storage-browser">
      <h1>{t('storage.browser.title')}</h1>
      <table aria-label="storage-table">
        <thead><tr><th>{t('storage.browser.col.key')}</th><th>{t('storage.browser.col.type')}</th><th>{t('storage.browser.col.size')}</th><th>{t('storage.browser.col.uploaded')}</th></tr></thead>
        <tbody>
          {rows.map((s) => (
            <tr key={s.key}>
              <td>{s.key}</td>
              <td>{s.contentType}</td>
              <td>{number(s.sizeBytes / 1024, 1)} KB</td>
              <td>{atDay(s.uploadedAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
